import { StringResponseBase } from "abweb/dto/generated/genericResponse/StringResponseBase";
export class StringResponse extends StringResponseBase {
  static createStringResponse(issue, payload) {
    const retVal = new StringResponse();
    retVal.initStringResponse(issue, payload);
    return retVal;
  }
  constructor() {
    super();
  }

  // Normally have to override initFromJson to decode the 'payload' any to the desired subtype,
  // but 'string' is a native json type so no decoding necessary

  get payload() {
    return super.payloadAny;
  }
  set payload(value) {
    super.payloadAny = value;
  }
}
//# sourceMappingURL=StringResponse.js.map
